// @flow

import React, { useState, useEffect } from 'react';
import { useInterval } from 'react-use';
import moment from 'moment';

import styled, { withTheme } from 'styled-components';
import { colors, ReskinThemes } from '../constants';
import { FieldNotice as Small } from '../typography';
import PrimaryPalette from '../../birch/colors';

type Props = {
  maxSeconds: number,
  onStop: () => void,
  theme?: { name: string },
};

const themeSelector = (themeName) => {
  return themeName !== ReskinThemes.BIRCH ? azaleaTheme : birchTheme;
};

const azaleaTheme = {
  timeUsedColor: colors.darkGrey,
  timeLeftColor: colors.mediumGrey,
};

const birchTheme = {
  timeUsedColor: PrimaryPalette.mediumEvergreen,
  timeLeftColor: PrimaryPalette.lightEvergreen,
};

const AudioTimer = (props: Props) => {
  const [secondsElapsed, setSecondsElapsed] = useState(0);

  useEffect(() => {
    if (secondsElapsed >= props.maxSeconds) props.onStop();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [secondsElapsed]);

  useInterval(() => setSecondsElapsed(secondsElapsed + 1), 1000);

  const timeUsed = moment(secondsElapsed.toString(), 'ss');
  const timeLeft = moment((props.maxSeconds - secondsElapsed).toString(), 'ss');

  return (
    <CounterWrapper data-provides="audio-timer">
      Recording {timeUsed.format('mm:ss')}
      <Small>{` / − ${timeLeft.format('mm:ss')}`}</Small>
    </CounterWrapper>
  );
};

AudioTimer.defaultProps = {
  maxSeconds: 10,
};

const CounterWrapper = styled.span`
  font-size: 14px;
  color: ${(props) => themeSelector(props.theme?.name).timeUsedColor};
  padding: 7px 15px;
  display: inline-block;
  vertical-align: middle;

  ${Small} {
    font-size: 14px;
    color: ${(props) => themeSelector(props.theme?.name).timeLeftColor};
  }
`;
export default withTheme(AudioTimer);
